export default "__VITE_ASSET__D1l9omBJ__"